import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import OfferPresentationCard from "./OfferPresentationCard";
const OfferPresentationCardPreview = () => {
    return (_jsx(OfferPresentationCard, { surtitle: "Le Pack cyber", isPriceCard: true, title: "15,99 EUR", titleComplement: "HT / poste / mois", titleFeatures: "Inclus dans le pack", barColor: "#0CFFC6", features: _jsxs("ul", { children: [_jsx("li", { children: "Postes de travail & serveurs supervis\u00E9s" }), _jsx("li", { children: "Patrimoine de donn\u00E9es s\u00E9curis\u00E9" })] }), plusFeature: "Acc\u00E8s \u00E0 mon espace client cyber", plusFeatureIcon: {
            icon: "desktop",
            type: "far",
            color: "#0000FF",
        } }));
};
export default OfferPresentationCardPreview;
